import KalmanFilter from 'kalmanjs';

class KalmanFilter3D {
  constructor(settings) {
    this.smoothX = new KalmanFilter(settings);
    this.smoothY = new KalmanFilter(settings);
    this.smoothZ = new KalmanFilter(settings);
  }

  smoothKeypoint(keypoint) {
    this.smoothX.filter(keypoint.x);
    this.smoothY.filter(keypoint.y);
    this.smoothZ.filter(keypoint.z);

    keypoint.x = this.smoothX.x;
    keypoint.y = this.smoothY.x;
    keypoint.z = this.smoothZ.x;
  }

  // update setting Q
  setMeasurementNoise(noise) {
    this.smoothX.setMeasurementNoise(noise);
    this.smoothY.setMeasurementNoise(noise);
    this.smoothZ.setMeasurementNoise(noise);
  }
}

export default KalmanFilter3D;
